/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * INewsletterBlock contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum position {
    Page = 'Page',
    Popup = 'Popup',
    Footer = 'Footer'
}

export const enum customExternalAPI {
    D365 = 'D365',
    External = 'External'
}

export const enum source {
    CommerceSubscriberEU = 'CommerceSubscriberEU',
    CommerceSubscribersUS = 'CommerceSubscribersUS',
    CommerceSubscribersAU = 'CommerceSubscribersAU',
    CommerceSubscribersSG = 'CommerceSubscribersSG',
    CommerceSubscribersHK = 'CommerceSubscribersHK',
    RetailEU = 'RetailEU',
    RetailUS = 'RetailUS',
    RetailAU = 'RetailAU',
    RetailSG = 'RetailSG',
    RetailHK = 'RetailHK'
}

export interface INewsletterBlockConfig extends Msdyn365.IModuleConfig {
    paragraph?: Msdyn365.RichText;
    privacyTextM?: Msdyn365.RichText;
    requiredMarketingError?: string;
    className?: string;
    position: position;
    customExternalAPI?: customExternalAPI;
    externalApiURL?: string;
    externalThankYouMessage?: string;
    source: source;
    preflagMarketing?: boolean;
    preflagProfiling?: boolean;
    preflagThirdParty?: boolean;
    hideMarketing?: boolean;
    hideProfiling?: boolean;
    hideThirdParty?: boolean;
    privacyPolicyURL?: string;
    useCrossCountryLabels?: boolean;
}

export interface INewsletterBlockResources {
    alreadySubscribedText: string;
    verifyEmailText: string;
    yourEmailAddressText: string;
    subscribeBtnText: string;
    htmlGenericMarketing: string;
    htmlProfiling: string;
    htmlThirdParty: string;
    htmlGenericMarketingCrossCountry: string;
    htmlProfilingCrossCountry: string;
    htmlThirdPartyCrossCountry: string;
    invalidEmailAddressError: string;
}

export interface INewsletterBlockProps<T> extends Msdyn365.IModule<T> {
    resources: INewsletterBlockResources;
    config: INewsletterBlockConfig;
}
